const Personal = () =>
    import ( /* webpackChunkName: "PersonalPatient" */ "@/components/registration/patient/PatientPersonalDetails");
const Adddress = () =>
    import ( /* webpackChunkName: "AddressPatient" */ "@/components/registration/patient/AddressDetails");
const MedicalHistory = () =>
    import ( /* webpackChunkName: "MedicalHistory" */ "@/components/registration/patient/MedicalHistory");
const LifeStyle = () =>
    import ( /* webpackChunkName: "LifeStyle" */ "@/components/registration/patient/LifeStyle");

const Disability = () =>
    import ( /* webpackChunkName: "Disability" */ "@/components/registration/patient/Disability");
const FamilyMedical = () =>
    import ( /* webpackChunkName: "FamilyMedical" */ "@/components/registration/patient/FamilyMedical");
const Dependent = () =>
    import ( /* webpackChunkName: "Dependant" */ "@/components/registration/patient/Dependent");
const PersonalSummary = () =>
    import ( /* webpackChunkName: "PersonalSummary" */ "@/components/registration/patient/summary/PatientPersonalSummary");
const AdddressSummary = () =>
    import ( /* webpackChunkName: "AddressSummary" */ "@/components/registration/patient/summary/AddressSummary");
const MedicalHistorySummary = () =>
    import ( /* webpackChunkName: "MedicalHistorySummary" */ "@/components/registration/patient/summary/MedicalHistorySummary");
const LifeStyleSummary = () =>
    import ( /* webpackChunkName: "LifestyleSummary" */ "@/components/registration/patient/summary/LifeStyleSummary");
const DisabilitySummary = () =>
    import ( /* webpackChunkName: "DisabilitySummary" */ "@/components/registration/patient/summary/DisabilitySummary");
const FamilyMedicalSummary = () =>
    import ( /* webpackChunkName: "FamilyMedicalSummary" */ "@/components/registration/patient/summary/FamilyMedicalSummary");
const DependentSummary = () =>
    import ( /* webpackChunkName: "DependentSummary" */ "@/components/registration/patient/summary/DependentSummary");

export default [{
        path: "",
        redirect: {
            name: "register.patient.owner"
        }
    },
    {
        path: "personal",
        name: "register.patient.owner",
        component: Personal
    },
    {
        path: "address",
        name: "register.patient.address",
        component: Adddress
    },
    {
        path: "medical-history",
        name: "register.patient.medicalHistory",
        component: MedicalHistory
    },
    {
        path: "life-style",
        name: "register.patient.lifeStyle",
        component: LifeStyle
    },
    {
        path: "disability",
        name: "register.patient.disability",
        component: Disability
    },
    {
        path: "family-medical",
        name: "register.patient.familyMedical",
        component: FamilyMedical
    },
    {
        path: "dependent",
        name: "register.patient.dependent",
        component: Dependent
    },
    {
        path: "summary",
        name: "register.patient.summary",
        redirect: {
            name: "register.patient.summary.personal"
        },
        component: {
            render(c) {
                return c("router-view");
            }
        },
        children: [{
                path: "personal",
                name: "register.patient.summary.personal",
                component: PersonalSummary
            },
            {
                path: "address",
                name: "register.patient.summary.address",
                component: AdddressSummary
            },
            {
                path: "medical-history",
                name: "register.patient.summary.medicalHistory",
                component: MedicalHistorySummary
            },
            {
                path: "life-style",
                name: "register.patient.summary.lifeStyle",
                component: LifeStyleSummary
            },
            {
                path: "disability",
                name: "register.patient.summary.disability",
                component: DisabilitySummary
            },
            {
                path: "family-medical",
                name: "register.patient.summary.familyMedical",
                component: FamilyMedicalSummary
            },
            {
                path: "dependent",
                name: "register.patient.summary.dependent",
                component: DependentSummary
            }
        ]
    }
];